import { useFormik } from "formik";
import axios from "axios";
import { Col, Container, Row, Form, Button } from "react-bootstrap";
import Layout from "../assets/component/Layout";
import { useNavigate } from "react-router-dom";

export const BASE_URL = process.env.REACT_APP_API_URL;

export default function LeaveApplicationForm() {
    const navigate = useNavigate();

    const formik = useFormik({
        initialValues: {
            name: "",
            rollNumber: "",
            department: "",
            leaveDateFrom: "",
            leaveDateTo: "",
            reason: "",
            contactDuringLeave: "",
            approvalSignature: "",
        },
        onSubmit: async (values) => {
            try {
                const token = localStorage.getItem("token");
                const response = await axios.post(`${BASE_URL}create-leave`, values, {
                    headers: { Authorization: token },
                });

                if (response.status === 200) {
                    navigate("/engineers-forms");
                }
            } catch (error) {
                console.error("Submission error:", error);
            }
        },
    });

    return (
        <Layout>
            <section className="Inner-page-layout">
                <div>
                    <h1>Leave Application Form</h1>
                    <div className="application-forms-cards">
                        <Container>
                            <Form onSubmit={formik.handleSubmit}>
                                <Row>
                                    <Col lg={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Student/Employee Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="name"
                                                placeholder="Type here . . ."
                                                onChange={formik.handleChange}
                                                value={formik.values.name}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col lg={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>ID Number/Roll Number</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="rollNumber"
                                                placeholder="Type here . . ."
                                                onChange={formik.handleChange}
                                                value={formik.values.rollNumber}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col lg={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Department/Class</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="department"
                                                placeholder="Type here . . ."
                                                onChange={formik.handleChange}
                                                value={formik.values.department}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col lg={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Leave Dates (From)</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="leaveDateFrom"
                                                placeholder="Type here . . ."
                                                onChange={formik.handleChange}
                                                value={formik.values.leaveDateFrom}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col lg={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Leave Dates (To)</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="leaveDateTo"
                                                placeholder="Type here . . ."
                                                onChange={formik.handleChange}
                                                value={formik.values.leaveDateTo}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col lg={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Reason for Leave</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="reason"
                                                placeholder="Type here . . ."
                                                onChange={formik.handleChange}
                                                value={formik.values.reason}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col lg={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Contact During Leave</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="contactDuringLeave"
                                                placeholder="Type here . . ."
                                                onChange={formik.handleChange}
                                                value={formik.values.contactDuringLeave}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col lg={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Approval Signature (by HOD/Principal)</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="approvalSignature"
                                                placeholder="Type here . . ."
                                                onChange={formik.handleChange}
                                                value={formik.values.approvalSignature}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <div className="text-center mt-3">
                                    <Button type="submit">Save</Button>
                                </div>
                            </Form>
                        </Container>
                    </div>
                </div>
            </section>
        </Layout>
    );
}
